import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { SearchState, StateWithSearch } from '../search-state';
import { getCustomSearchState } from './feature.selector';

type FacetsTotalResultsState = SearchState['totalResults'];

export const getSearchFacetsTotalResultsState: MemoizedSelector<StateWithSearch, FacetsTotalResultsState> =
  createSelector(getCustomSearchState, (state: SearchState) => state.totalResults);

export const getSearchFacetsTotalResultsValue: MemoizedSelector<StateWithSearch, number> = createSelector(
  getSearchFacetsTotalResultsState,
  (state: StateUtils.LoaderState<number>) => StateUtils.loaderValueSelector(state),
);

export const getSearchFacetsTotalResultsLoading: MemoizedSelector<StateWithSearch, boolean> = createSelector(
  getSearchFacetsTotalResultsState,
  (state: StateUtils.LoaderState<number>) => StateUtils.loaderLoadingSelector(state),
);

export const getSearchFacetsTotalResultsError: MemoizedSelector<StateWithSearch, boolean> = createSelector(
  getSearchFacetsTotalResultsState,
  (state: StateUtils.LoaderState<number>) => StateUtils.loaderErrorSelector(state),
);

export const getSearchFacetsTotalResultsSuccess: MemoizedSelector<StateWithSearch, boolean> = createSelector(
  getSearchFacetsTotalResultsState,
  (state: StateUtils.LoaderState<number>) => StateUtils.loaderSuccessSelector(state),
);
